// RadioOptions.js
export const RadioOptions = [
    { value: "0", label: "Nada" },
    { value: "1", label: "Un poco" },
    { value: "2", label: "Moderadamente" },
    { value: "3", label: "Bastante" },
    { value: "4", label: "Mucho" },
  ];
  